import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { Producto } from '../../types';
import { ProductDetail } from '../ProductDetail/ProductDetail';

interface ProductDetailModalProps {
  open: boolean;
  producto: Producto | null;
  onClose: () => void;
  onEdit?: (producto: Producto) => void;
}

export function ProductDetailModal({
  open,
  producto,
  onClose,
  onEdit,
}: ProductDetailModalProps) {
  if (!producto) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalles del Producto</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <ProductDetail
          producto={producto}
          loading={false}
          error={null}
          onEdit={() => {
            onClose();
            onEdit?.(producto);
          }}
          onBack={onClose}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
